import { ref, watch } from 'vue'
import { useLoadProtectWidget } from './api'

const useModel = () => {
  const items = ref<{ id: number; value: number; description: string }[]>([])
  const count = ref(0)

  const loadData = () => {
    const result = useLoadProtectWidget()

    watch(result.data, () => {
      if (result.data.value) {
        items.value = result.data.value.data.monitor_sensors
        count.value = result.data.value.data.protect_count
      }
    })

    return result
  }

  return {
    items,
    count,

    loadData,
  }
}

export default useModel
